export default __webpack_public_path__ + "static/media/dateComparisonImage.21c560d4.png";